import {
    Box,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Tooltip,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const ButtonGroupOptions = ({
    anchorRef,
    options,
    selectedIndex,
    openOptionButton,
    handleClose,
    handleMenuItemClick,
    handleToggle,
}: {
    anchorRef: React.RefObject<HTMLDivElement>;
    options: { label: string; tooltip: string }[];
    selectedIndex: number;
    openOptionButton: boolean;
    handleClose: (event: Event) => void;
    handleMenuItemClick: (index: number) => void;
    handleToggle: () => void;
}) => {
    return (
        <Box>
            <ButtonGroup
                variant="outlined"
                ref={anchorRef}
                sx={{ boxShadow: 'none' }}
            >
                <Tooltip title={options[selectedIndex].tooltip} arrow>
                    <Button onClick={handleToggle} variant="outlined">
                        {options[selectedIndex].label}
                    </Button>
                </Tooltip>
                <Button
                    size="small"
                    aria-controls={
                        openOptionButton ? 'split-button-menu' : undefined
                    }
                    aria-expanded={openOptionButton ? 'true' : undefined}
                    aria-haspopup="menu"
                    onClick={handleToggle}
                    variant="outlined"
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{ zIndex: 1 }}
                open={openOptionButton}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom'
                                    ? 'center top'
                                    : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            selected={index === selectedIndex}
                                            onClick={() =>
                                                handleMenuItemClick(index)
                                            }
                                        >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Box>
    );
};
